/* Charmhabit: aanbevelingen in cart drawer en /cart (Claude, 20-10-2026).
   Bronnen in volgorde: Product Recommendations API (complementary, dan related) voor het eerste item,
   daarna collectie favorieten en als laatste collections/all, allemaal via de Section Rendering API (section ch-cart-recs).
   Filtert wat al in de cart zit (Liquid filtert beschikbaarheid en tag personalisatie-naam).
   Toevoegen via /cart/add.js; drawer en /cart worden ververst zonder herladen. */
(() => {
  if (customElements.get('ch-cart-recs')) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cache = new Map();

  function load(url) {
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : ''))
        .then((t) => [...new DOMParser().parseFromString(t, 'text/html').querySelectorAll('[data-ch-rec]')])
        .catch(() => []));
    }
    return cache.get(url);
  }

  function sectionHTML(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  class ChCartRecs extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.list = this.querySelector('.ch-recs__list');
      this.picker = this.querySelector('.ch-recs__picker');
      this.status = this.querySelector('.ch-recs__status');
      this.addEventListener('click', (e) => this.onClick(e));
      // change niet laten doorbubbelen: cart-items/cart-drawer-items behandelen elke change als aantal-wijziging.
      this.addEventListener('change', (e) => { e.stopPropagation(); if (e.target.closest('.ch-recs__picker')) this.syncPicker(); });
      this.addEventListener('keyup', (e) => { if (e.key === 'Escape' && !this.picker.hidden) { e.stopPropagation(); this.closePicker(true); } });
      this.render();
    }

    async render() {
      const pid = this.dataset.productId;
      const inCart = new Set((this.dataset.cartIds || '').split(',').filter(Boolean));
      const max = parseInt(this.dataset.max || '4', 10);
      const urls = [];
      if (pid) {
        const base = `${root}recommendations/products?product_id=${encodeURIComponent(pid)}&limit=8&section_id=ch-cart-recs&intent=`;
        urls.push(base + 'complementary', base + 'related');
      }
      urls.push(`${root}collections/favorieten?section_id=ch-cart-recs`, `${root}collections/all?section_id=ch-cart-recs`);
      const results = await Promise.all(urls.map(load));
      const seen = new Set();
      const picked = [];
      for (const list of results) {
        for (const el of list) {
          const id = el.dataset.productId;
          if (seen.has(id) || inCart.has(id)) continue;
          seen.add(id);
          picked.push(el);
          if (picked.length >= max) break;
        }
        if (picked.length >= max) break;
      }
      if (!this.isConnected) return;
      if (!picked.length) { this.hidden = true; return; }
      this.list.replaceChildren(...picked.map((el) => {
        const node = document.importNode(el, true);
        node.setAttribute('role', 'listitem');
        return node;
      }));
      this.hidden = false;
    }

    onClick(e) {
      const add = e.target.closest('.ch-rec__add');
      if (add) {
        const card = add.closest('.ch-rec');
        if (add.hasAttribute('data-direct')) this.add(add.dataset.variantId, add);
        else if (this.activeCard === card) this.closePicker(true);
        else this.openPicker(card, add);
        return;
      }
      if (e.target.closest('.ch-recs__cancel')) { this.closePicker(true); return; }
      const confirm = e.target.closest('.ch-recs__confirm');
      if (confirm && this.variant && this.variant.a) this.add(this.variant.id, confirm);
    }

    openPicker(card, trigger) {
      this.closePicker(false);
      let data;
      try { data = JSON.parse(card.querySelector('.ch-rec__json').textContent); } catch (err) { return; }
      this.data = data;
      this.activeCard = card;
      this.trigger = trigger;
      card.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-controls', this.picker.id);
      this.picker.querySelector('.ch-recs__picker-title strong').textContent = data.title;
      const fields = this.picker.querySelector('.ch-recs__picker-fields');
      fields.replaceChildren(card.querySelector('.ch-rec__tpl').content.cloneNode(true));
      this.picker.hidden = false;
      this.syncPicker();
      const first = fields.querySelector('select');
      if (first) first.focus();
      this.picker.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    closePicker(returnFocus) {
      if (this.activeCard) this.activeCard.classList.remove('is-active');
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) this.trigger.focus();
      }
      this.activeCard = this.trigger = this.variant = null;
      this.picker.hidden = true;
    }

    syncPicker() {
      if (!this.data) return;
      const inputs = [...this.picker.querySelectorAll('[data-index]')].sort((a, b) => a.dataset.index - b.dataset.index);
      const chosen = inputs.map((i) => i.value);
      const variants = this.data.variants;
      // Markeer opties die met de huidige andere keuzes niet beschikbaar zijn.
      inputs.forEach((input, idx) => {
        if (input.tagName !== 'SELECT') return;
        [...input.options].forEach((opt) => {
          const ok = variants.some((v) => v.a && v.o[idx] === opt.value && v.o.every((val, j) => j === idx || val === chosen[j]));
          opt.disabled = !ok && !opt.selected;
        });
      });
      this.variant = variants.find((v) => v.o.every((val, j) => val === chosen[j])) || null;
      const btn = this.picker.querySelector('.ch-recs__confirm');
      const label = btn.querySelector('span');
      const price = this.picker.querySelector('.ch-recs__picker-price');
      label.dataset.text = label.dataset.text || label.textContent;
      const ok = !!(this.variant && this.variant.a);
      btn.disabled = !ok;
      label.textContent = ok ? label.dataset.text : this.dataset.strUnavailable;
      price.textContent = this.variant ? `· ${this.variant.p}` : '';
    }

    async add(variantId, btn) {
      if (!variantId || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      btn.classList.add('loading');
      this.status.textContent = '';
      const drawer = document.querySelector('cart-drawer');
      const mainItems = document.getElementById('main-cart-items');
      const mainFooter = document.getElementById('main-cart-footer');
      const sections = ['cart-icon-bubble'];
      if (drawer) sections.push('cart-drawer');
      if (mainItems && mainItems.dataset.id) sections.push(mainItems.dataset.id);
      if (mainFooter && mainFooter.dataset.id) sections.push(mainFooter.dataset.id);
      const addUrl = `${(window.routes && window.routes.cart_add_url) || root + 'cart/add'}.js`;
      try {
        const res = await fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sections.join(','), sections_url: window.location.pathname }),
        });
        const json = await res.json();
        if (!res.ok || json.status) throw new Error(json.description || json.message || 'add failed');
        const s = json.sections || {};
        const live = this.dataset.strAdded;
        if (mainItems) {
          // Op /cart: ververs regels, totalen, icoon en (gesloten) drawer.
          const items = s[mainItems.dataset.id] && sectionHTML(s[mainItems.dataset.id], '#main-cart-items .js-contents');
          if (items != null) mainItems.querySelector('.js-contents').innerHTML = items;
          if (mainFooter) {
            const foot = s[mainFooter.dataset.id] && sectionHTML(s[mainFooter.dataset.id], '.js-contents');
            const target = mainFooter.querySelector('.js-contents');
            if (foot != null && target) target.innerHTML = foot;
            mainFooter.classList.remove('is-empty');
          }
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && s['cart-icon-bubble']) { const b = sectionHTML(s['cart-icon-bubble'], '.shopify-section'); if (b != null) bubble.innerHTML = b; }
          if (drawer && s['cart-drawer']) {
            const d = sectionHTML(s['cart-drawer'], '#CartDrawer');
            const target = document.getElementById('CartDrawer');
            if (d != null && target) target.innerHTML = d;
            drawer.classList.remove('is-empty');
          }
          const status = document.getElementById('cart-live-region-text');
          if (status) status.textContent = live;
        } else if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(json);
          setTimeout(() => {
            const region = document.getElementById('CartDrawer-LiveRegionText');
            if (region) region.textContent = live;
          }, 50);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
      } catch (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        btn.classList.remove('loading');
        if (this.isConnected) this.status.textContent = err && err.message && err.message !== 'add failed' ? err.message : this.dataset.strError;
      }
    }
  }

  customElements.define('ch-cart-recs', ChCartRecs);
})();
